module.exports = __webpack_public_path__ + "img/skinpay.b8fea4b7.svg";